import React from 'react';
const ProtocolloContext = React.createContext({ context: null, allowedUserRoles: null, currentRole: null, roleIsReadOnly: true });
export default ProtocolloContext;